/* istanbul ignore file */
import OneStopFilter from 'domain/gpo/oneStop/List/OneStopFilter';
import OneStopListLayout from 'domain/gpo/oneStop/List/OneStopListLayout';
import OneStopListPageLayout from 'domain/gpo/oneStop/List/OneStopListPageLayout';
import { useOneStopService, FILTER_TABS } from 'domain/shared/oneStop';
import { ListHeader, List } from 'framework/list';

const OneStopList = () => {
  const { search, getSections } = useOneStopService();

  const requestsList = <OneStopListLayout />;
  const filter = <OneStopFilter getSections={getSections} requestsList={requestsList} />;

  return (
    <List getDataMethod={search} defaultFilter={{ section: { eq: FILTER_TABS.RECENT } }}>
      <OneStopListPageLayout
        filter={filter}
        requestsList={requestsList}
        header={<ListHeader label="New Request" icon="fa-plus-square font-3xl" />}
      />
    </List>
  );
};

export default OneStopList;
